export enum KidsCourseTag {
    Projects = 1,
    LearningMaterials = 2,
}
